import React, { useState } from "react";
import ResumeCard from "./ResumeCard";

function ResumeContent() {
  //   const [roles, setRoles] = useState([
  const [roles] = useState([
    {
      id: "ingenio",
      year: "2019 - 2020",
      company: "IngenioRx (Anthem)",
      url: "https://www.ingenio-rx.com",
      location: "Midtown, Atlanta",
      title: "Lead Product Designer for enterprise applications",
      summaryList: [
        "Leading UX and UI for a major application build",
        "Angular theming and modular prototyping",
        "Collaboration and design direction for Product, Engineering, and QA teams",
      ],
      description: [
        "Ingenio is a startup within the Anthem group of companies focused on Pharmacy Benefits Management (PBM).",
        "As the only UX/UI resource I played a key role in establishing a design process and delivering a first-version launch of the 'Eligibility' application. The users of this application were highly specialised and the UX/UI had to make the complexity of membership eligibility data accessible and easy to find.",
        "The team included DevOps, systems architects, Java engineers, cloud and security specialists, QA, product owners, and business end-users. I led the co-ordination of skills relating to the successful delivery and quality of the application UI.",
      ],
    },
    {
      id: "iglu",
      year: "2017 - 2019",
      company: "IgluCruise.com",
      url: "https://www.iglucruise.com/",
      location: "London, UK",
      title: "Lead UX Designer for e-commerce",
      summaryList: [
        "Qualitative and quantitative user testing: A/B testing, lab testing, analytics and user-behaviour instruments",
        "Leading design and collaboration with Product, Development, Commercial and Marketing teams",
        "Ideation, prototyping, production-ready HTML",
        "Responsive design / mobile first",
        "Pattern library development",
      ],
      description: [
        "I was the first designer to join a new team with the remit of growing online sales for Iglu Cruise and Planet Cruise; a successful company but with mostly 'off-line' sales. All design outputs were measured against Key Performance Indicators (KPIs) guiding the way for a constantly improving user experience and growth of e-commerce sales.",
        "I delivered successful designs that improved product search, customising cruise holidays, and for the checkout funnel. Design had to succeed for mobile, tablet, and desktop users across varying and distinct European markets.",
        "I helped build a design team that worked to Lean UX principles; contintually releasing, testing, and learning from new designs and progressive enhancement.",
      ],
    },
    {
      id: "orckid",
      year: "2013 - 2017",
      company: "Orckid.com",
      url: "https://orckid.com/",
      location: "London, UK",
      title: "Senior Digital Designer for web apps",
      summaryList: [
        "UX/UI for web apps",
        "Wireframing & prototyping",
        "Responsive design - mobile, tablet, desktop",
        "Bespoke Wordpress theming for small-business websites",
        "Leading digital design for the studio",
      ],
      description: [
        "I assisted this creative studio in advancing its digital experiences service for a wide range of clientele. I worked on projects including e-commerce for Verbatim.com, marketing campaigns for Britishgas.co.uk, and bespoke applications for MyFamilyCare.co.uk.",
        "The skills I brought to client projects included: ideation, wireframing, prototyping, creative designs, front-end builds, collaborating with developers, and directly advising clients on technologies and UX best practices.",
      ],
    },
    {
      id: "amazon",
      year: "2012 - 2013",
      company: "Amazon.co.uk",
      url: "https://www.amazon.co.uk/",
      location: "London, UK",
      title: "Visual Experience Designer for European markets",
      summaryList: [
        "Design for marketing and product campaigns, including Black Friday and Cyber Monday",
        "UI design and prototyping",
        "Collaborating with distributed design and commercial teams",
      ],
      description: [
        "I joined a design team charged with developing vision and elevating creative digital outputs that touch millions of Amazon customers across UK, Germany, France, Italy, and Spain.",
        "I provided creative design for product and marketing campaigns in many languages. I participated in regular ideation sessions and collaborated with distributed design and commercial teams to achieve high-quality outputs.",
        "A key project I led and crafted was a Christmas marketing campaign that was released across all categories on each of the major European sites: .co.uk, .fr, .de, .es, and .it",
      ],
    },
    {
      id: "mdd",
      year: "2010 - 2012",
      company: "Martin Duggan Design",
      url: "http://martinduggan.com/folio12/index.php",
      location: "Ireland & UK",
      title: "Design Consultant for Startups and SMEs",
      summaryList: [
        "Brand development and role-out for SMEs",
        "Consultancy for tech startups",
        "In-agency project work, Dublin & London",
      ],
      description: [
        "I ran my own design consultancy focusing on tech startups and small-to-medium sized businesses.",
        "I provided UX and UI consultancy for Youtipit, a startup based in Germany and one of the first Bitcoin applications for 'tipping' content creators; a precursor to Patreon.",
        "Along with startups, I worked closely with company owners to craft a design strategy to grow their businesses. I found it very rewarding to have key insights into the effectiveness of the design work I produced. A client in retail estimated a 10% increase in sales due to a well-thought out instore branding campaign I contributed to.",
        "Another key client was the German pharmacy chain DocMorris. As they were entering the Irish market, I developed in-store graphics, marketing materials, and UX/UI for an application providing customers access to advice from a DocMorris pharmacy expert.",
      ],
    },
    {
      id: "hod",
      year: "1998 - 2010",
      company: "House of Design",
      url: "https://houseofdesign.ie/",
      location: "Ireland & UK",
      title: "Senior Designer",
      summaryList: [
        "Art Direction, mentoring designers",
        "Corporate Identity development",
        "Web apps and marketing sites",
        "In-charge of new client procurement",
      ],
      description: [
        "Initially my role was creative solutions for printed media. This included corporate identity design and implementation, annual reports, packaging, magazine layout, sales and marketing materials.",
        "I managed and delivered on client accounts worth many hundreds of thousands (Euro) in annual turnover.",
        "In this small agency, I took charge of procuring new public-sector contracts via successful tendering.",
        "Increasingly, our clients requested company websites to be designed, built, and hosted; we provided that full service. As our digital service grew, I mentored new designers in the growing discipline of User Experience design. I paid close attention to leading voices in the UX industry and advised clients on successful patterns.",
        "From successful marketing sites, requests for digital products and apps grew. I expanded our design service to include basic personas, user journeys, wireframing, and use of Google Analytics.",
        "I led the design and build of .NET applications in the health, construction, and automated printing space.",
      ],
    },
    {
      id: "kandt",
      year: "1997 - 1998",
      company: "Kunnert+Tierney",
      url: "http://www.kunnertandtierney.com/",
      location: "Cork, Ireland ",
      title: "Designer & Creative Artworker",
      summaryList: [
        "Creative design for small business marketing",
        "Artwork preparation for print",
      ],
      description: [
        "As a junior designer I assisted this highly-creative boutique studio in identity design and marketing for small businesses. I assisted senior designers in preparing mockups for clients and helped in artwork preparation for print.",
        "A key project I participated in was a product photo-shoot (pre-digital) for a renowned and prestigious Jewellers (keanes.ie). ",
      ],
    },
  ]);

  return (
    <>
      {roles.map((role) => (
        <ResumeCard
          key={role.id}
          year={role.year}
          company={role.company}
          site={role.url}
          location={role.location}
          title={role.title}
          summary={role.summaryList}
          description={role.description}
        />
      ))}
    </>
  );
}

export default ResumeContent;
